const c = (l, e) => (e == null ? void 0 : e.find((n) => n.id === l)) ?? null;
export {
  c as getSelectedData
};
